import { AccountRole } from 'models/account.model';
import {
  AccountRightsDefs, Action, RightsType, Subject
} from 'models/roles.model';

export const dealerRightsDefinitions: AccountRightsDefs = {
  [Subject.Customer]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.ContactPerson]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Objekt]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Conditions]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Templates]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Read],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Articles]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Branch]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [Action.Read],
      [AccountRole.ADMIN]: [Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Read, Action.Update]
    }
  },

  [Subject.OfferTemplates]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    },
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.OfferTemplateSettings]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    },
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.OfferSettings]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    },
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Account]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update]
    },
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update]
    }
  },

  [Subject.Branches]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Read]
    },
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },

  [Subject.HeaderNavSettings]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    },
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },

  [Subject.ImportCustomer]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },
  [Subject.ExportCustomer]: {
    [RightsType.Branch]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },

  [Subject.ImportArticles]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.ExportArticles]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },
};
